// ===================================
// KAIXO - Barra horizontal de historias activas
// Se monta arriba del feed de Latidos. Cada avatar con anillo degradado
// representa un canal con historias vigentes (<24h). Al tocar, se abre
// StoriesViewer autoavance.
// ===================================

import React, { useEffect, useState } from 'react';
import { v2GetStories } from '../../services/api';
import StoriesViewer from './StoriesViewer';
import './StoriesBar.css';

export default function StoriesBar({ refreshKey = 0 }) {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openGroupIdx, setOpenGroupIdx] = useState(-1);
    // Incremento local para forzar refetch tras publicar una historia.
    // El prop refreshKey externo solo se mueve cuando cambia el feed,
    // pero las historias no entran al feed → nunca se refrescaba.
    const [localRefresh, setLocalRefresh] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        v2GetStories()
            .then(({ data }) => { if (!cancelled) setGroups(data?.groups || []); })
            .catch(() => { if (!cancelled) setGroups([]); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [refreshKey, localRefresh]);

    // Escucha el evento global 'v2_post_published' que dispara PublishModal;
    // si la publicación fue una historia, refrescamos para que aparezca
    // inmediatamente sin tener que cerrar y reabrir el feed.
    useEffect(() => {
        const handler = (e) => {
            if (e.detail?.isStory) setLocalRefresh(k => k + 1);
        };
        window.addEventListener('v2_post_published', handler);
        return () => window.removeEventListener('v2_post_published', handler);
    }, []);

    if (loading && groups.length === 0) return null;
    if (groups.length === 0) return null;

    return (
        <>
            <div className="sb-wrap">
                <div className="sb-track">
                    {groups.map((g, i) => (
                        <button
                            key={g.channel._id}
                            className="sb-item"
                            onClick={() => setOpenGroupIdx(i)}
                        >
                            <div className="sb-ring">
                                <div className="sb-avatar">
                                    {g.channel.avatar
                                        ? <img src={g.channel.avatar} alt="" loading="lazy" decoding="async" />
                                        : <span>{(g.channel.name?.[0] || '?').toUpperCase()}</span>}
                                </div>
                            </div>
                            <div className="sb-name">{g.channel.name}</div>
                        </button>
                    ))}
                </div>
            </div>
            {openGroupIdx >= 0 && (
                <StoriesViewer
                    groups={groups}
                    startGroupIdx={openGroupIdx}
                    onClose={() => setOpenGroupIdx(-1)}
                />
            )}
        </>
    );
}
